// Sidebar.tsx
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useAgency } from "../Common/agencyBrandingData";


interface SidebarProps {
  isOpen: boolean;
  onClose: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ isOpen, onClose }) => {

  const agency = useAgency();

  const location = useLocation();
  const currentPath = location.pathname;



  return (
    <>
      {/* Overlay */}
      <div
        onClick={onClose}
        style={{
          position: "fixed",
          top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: "rgba(0,0,0,0.5)",
          zIndex: 1040,
          display: isOpen ? "block" : "none",
        }}
      />

      {/* Sidebar */}
      <nav
        id="sidebar"
        className={`sidebar ${isOpen ? "open" : "closed"} mobile-sidebar`}
      >
       <span onClick={onClose} className="close-btn"><i className="fas fa-times" style={{ fontSize: "20px", color: "#828383", cursor: "pointer" }}></i></span>
        <div className="agency-logo">
          <img src={agency.data.agency_logo} alt="" height="21" />
          <p className="mb-0"
              style={{
                maxWidth: "70%",
                wordWrap: "break-word",
                whiteSpace: "normal", 
              }}
          >{agency.data.agency_name}</p>
        </div>
        <div className="menu-items-list">
          <div className={`menu-item sidebar-menu ${currentPath === "/analytics" ? "active" : ""}`}>
            <img src="/assets/icons/analytics.svg" alt="Analytics Icon" className="nav-icon" />
            <Link to="/analytics" onClick={onClose}>Analytics</Link>
          </div>
          <div className={`menu-item sidebar-menu ${currentPath === "/reports" ? "active" : ""}`}>
            <img src="/assets/icons/reports.svg" alt="Reports Icon" className="nav-icon" />
            <Link to="/reports" onClick={onClose}>Reports</Link>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Sidebar;
